import { weatherMachineChapters } from './content';
export const weatherMachineCommonMistakes = weatherMachineChapters.find((chapter) => chapter.title.toLocaleUpperCase('pl').includes('NAJCZĘSTSZE BŁĘDY'));
